import { Card, CardContent } from 'src/component/ui/card'
import { Skeleton } from 'src/component/ui/skeleton'

export const ChoosePlanSkeleton = (): React.ReactElement => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      {[1, 2].map((index) => (
        <Card key={index} className="bg-secondary-gray border-none">
          {/* Mirrors the image height in `choose-plan.tsx` — they must move together or the
              loaded state jumps. */}
          <Skeleton className="h-[200px] sm:h-[clamp(200px,28dvh,410px)] w-full rounded-t-lg rounded-b-none" />
          <CardContent className="!p-5">
            <Skeleton className="h-10 w-3/4 mb-3" />
            <Skeleton className="h-7 w-1/2 mb-6 sm:mb-12" />
            <Skeleton className="h-9 w-[130px] rounded-full" />
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
